import React, { ReactElement } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { CacheProvider } from "@emotion/react";

import Theme from "./";
import Cache from "./cache";

import { useRTL } from "../hooks/useLanguage/useRTL";

interface IProps {
  children: ReactElement | ReactElement[];
}

const AppThemeProvider: React.FC<IProps> = ({ children }) => {
  const { isRTL } = useRTL();

  return (
    <CacheProvider value={Cache(isRTL)}>
      <ThemeProvider theme={Theme(isRTL)}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default AppThemeProvider;
